import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["operation", "submit"]
  static values = { confirm: String, destructiveOperation: String }

  connect() {
    this.update()
  }

  update() {
    if (this.operationTarget.value === this.destructiveOperationValue) {
      this.submitTarget.setAttribute("data-turbo-confirm", this.confirmValue)
    } else {
      this.submitTarget.removeAttribute("data-turbo-confirm")
    }
  }
}
